import React, {useEffect, useState} from 'react';
import PivotalSearchApi from "../../../js/csf/pivotal/PivotalSearchApi";
import {stopLoadingSpinner} from "./utils";

export default function CsfBrokerDashboard(props) {

  const [state, setState] = useState({
    ConsentResponseRate: 0,
    avgConsentResponseRate: 0,
    inOrderCurrPeriodRate: 0,
    avgInOrderCurrPeriodRate: 0,
    mandatoryCurrPeriodRate: 0,
    avgMandatoryCurrPeriodRate: 0,
  });

  useEffect(() => {
    if (props.token) {
      fetchApiData();
    }
  }, [props.token]);

  /*
  * Method to fetch the data needed to build the dashboard boxes
  * */
  const fetchApiData = () => {

    const requestData = buildMainBodyDataResquest();
    const pivotalSearchApi = new PivotalSearchApi(props.apiUrl, props.apiEnv, props.token);
    pivotalSearchApi.callSearchEndpoint(requestData, '_Courtier')
      .then(response => {
        if (response &&
          response.success &&
          response.payload &&
          response.payload.data &&
          response.payload.data.rows &&
          response.payload.data.rows.length >= 0) {
          const data = response.payload.data.rows[0];
          setState({
            ...state,
            ConsentResponseRate: data.Consent_Response_Rate,
            avgConsentResponseRate: data.Avg_Consent_Response_Rate,
            inOrderCurrPeriodRate: data.In_order_curr_Period_Rate,
            avgInOrderCurrPeriodRate: data.Avg_In_order_curr_Period_Rate,
            mandatoryCurrPeriodRate: data.Mandatory_curr_Period_Rate,
            avgMandatoryCurrPeriodRate: data.Avg_Mandatory_curr_Period_Rate,
          });
        }
      })
      .catch(error => {
        console.error(error);
      });
  };


  /*
  * Method to build the body array for the search
  * */
  const buildMainBodyDataResquest = () => {
    let requestData = {
      search: 'CSF_CRC_Dashboard_Values',
    };
    return requestData;
  }

  return (
    <div className="broker-dashboard">
      <div className="broker__dashboard mb-3">
        <div className="row">
          <div className="col">
            <div className="dashboard__item dashboard__item--answer">
              <h3 className="dashboard__item--title">{window.Drupal.t('broker.dashboard.consent_rate')}</h3>
              <div className="bottom">
                <div className="dashboard__item--results">
                  <div className="percentage">{Math.round(state.ConsentResponseRate * 100)} %</div>
                  <div
                    className="average">{window.Drupal.t('broker.dashboard.average_label')} : {Math.round(state.avgConsentResponseRate * 100)}% <span
                    className="indicator"><i
                    className={`icon ${state.ConsentResponseRate >= state.avgConsentResponseRate ? 'icon-csf-arrow-up' : 'icon-csf-arrow-down1'}`}></i></span>
                  </div>
                </div>
                <div className="dashboard__item--progress-bar">
                  <div className="progression" style={{width: `${Math.round(state.ConsentResponseRate * 100)}%`}}></div>
                </div>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="dashboard__item dashboard__item--conform">
              <h3 className="dashboard__item--title">{window.Drupal.t('broker.dashboard.compliance_rate_UFC')}</h3>
              <div className="bottom">
                <div className="dashboard__item--results">
                  <div className="percentage">{Math.round(state.inOrderCurrPeriodRate * 100)} %</div>
                  <div
                    className="average">{window.Drupal.t('broker.dashboard.average_label')} : {Math.round(state.avgInOrderCurrPeriodRate * 100)}% <span
                    className="indicator"><i
                    className={`icon ${state.inOrderCurrPeriodRate >= state.avgInOrderCurrPeriodRate ? 'icon-csf-arrow-up' : 'icon-csf-arrow-down1'}`}></i></span>
                  </div>
                </div>
                <div className="dashboard__item--progress-bar">
                  <div className="progression"
                       style={{width: `${Math.round(state.inOrderCurrPeriodRate * 100)}%`}}></div>
                </div>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="dashboard__item dashboard__item--completion">
              <h3 className="dashboard__item--title">{window.Drupal.t('broker.dashboard.mandatory_rate')}</h3>
              <div className="bottom">
                <div className="dashboard__item--results">
                  <div className="percentage">{Math.round(state.mandatoryCurrPeriodRate * 100)} %</div>
                  <div
                    className="average">{window.Drupal.t('broker.dashboard.average_label')} : {Math.round(state.avgMandatoryCurrPeriodRate * 100)}% <span
                    className="indicator"><i
                    className={`icon ${state.mandatoryCurrPeriodRate >= state.avgMandatoryCurrPeriodRate ? 'icon-csf-arrow-up' : 'icon-csf-arrow-down1'}`}></i></span>
                  </div>
                </div>
                <div className="dashboard__item--progress-bar">
                  <div className="progression"
                       style={{width: `${Math.round(state.mandatoryCurrPeriodRate * 100)}%`}}></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
